import React, { Component } from 'react';
import moment from 'moment';
import Select from 'react-select';
import DateRange from './Components/DateRange';
import queryString from 'query-string';
import NumberFormat from 'react-number-format';
import LocationOption from '../../../_components/Options/LocationOption'
import ProfessionalOption from '../../../_components/Options/ProfessionalOption'
import PreVisitQuestionOption from '../../../_components/Options/PreVisitQuestionOption'

import { history } from '../../../_helpers/history';

class SearchFilters extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      appointmentDate: '',
      appointmentStartDate: '',
      appointmentEndDate: '',
      invalidStart: false,
      invalidEnd: false,
      location: '',
      professional: '',
      preVisitQuestionId: '',
      status: '',
      invalidDate: false,
      invalidDOB: false,
      showDateRange: false,
    }

    this.statusOptions = [
      { value: 'SCHEDULED', label: 'Scheduled' },
      { value: 'SENT', label: 'Sent' },
      { value: 'COMPLETED', label: 'Completed' },
      { value: 'CANCELED', label: 'Canceled' },
      { value: 'EXPIRED', label: 'Expired' }
    ];

    this.setParams = this.setParams.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleDateRange = this.toggleDateRange.bind(this);
  }

  componentDidMount() {
    this.setParams()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setParams();
    }
  }

  toggleDateRange(e) {
    e.preventDefault();
    if (this.state.showDateRange) {
      this.setState({ appointmentStartDate: "", appointmentEndDate: "" })
    } else {
      this.setState({ appointmentDate: "" })
    }
    this.setState((prevState) => {
      return { ...prevState, showDateRange: !prevState.showDateRange }
    });
  }

  setParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("appointmentStartDate" in queryParams) ? true : false;

    this.setState({
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      showDateRange: showDateRange,
      appointmentDate: !showDateRange ? queryParams.appointmentDate || '' : '',
      appointmentStartDate: showDateRange && queryParams.appointmentStartDate ? new Date(queryParams.appointmentStartDate) || '' : '',
      appointmentEndDate: showDateRange && queryParams.appointmentEndDate ? new Date(queryParams.appointmentEndDate) || '' : '',
      location: queryParams.location ? parseInt(queryParams.location) : '',
      professional: queryParams.professional ? parseInt(queryParams.professional) : '',
      preVisitQuestionId: queryParams.preVisitQuestionId ? parseInt(queryParams.preVisitQuestionId) : '',
      status: queryParams.status || ''
    });
  }

  handleSearch() {
    let invalidDate = false,
      invalidDOB = false,
      invalidStart = false,
      invalidEnd = false;

    this.setState({ invalidDOB, invalidDate, invalidStart, invalidEnd });

    const dates = ["dateOfBirth"];

    if (!this.state.showDateRange) {
      dates.push("appointmentDate");
    }
    else {
      const start = this.state.appointmentStartDate;
      const end = this.state.appointmentEndDate;

      if (!start && end) {
        return this.setState({ invalidStart: true })
      }
      if (start && !end) {
        return this.setState({ invalidEnd: true })
      }
    }

    for (const type of dates) {
      let invalid = false;

      const date = this.state[type] !== '' ? moment(this.state[type]).format("L") : '';

      if (date && date.replace(/\D/g, '').length !== 8) {
        invalid = true;
      }
      else if (date && !moment(date, 'MM/DD/YYYY').isValid()) {
        invalid = true;
      }

      if (invalid === true) {
        switch (type) {
          case "dateOfBirth":
            invalidDOB = true;
            this.setState({ invalidDOB });
            return;
          case "appointmentDate":
            invalidDate = true;
            this.setState({ invalidDate });
            return;
          case "appointmentStartDate":
            invalidStart = true;
            this.setState({ invalidStart });
            return;
          case "appointmentEndDate":
            invalidEnd = true;
            this.setState({ invalidEnd });
            return;
          default:
            break;
        }
      }
    }

    if (!invalidDOB && !invalidDate && !invalidStart && !invalidEnd) {
      this.props.handleSearch(this.state);
    }
  }

  render() {
    const statusSelected = this.statusOptions.find((option) => {
      return option.value === this.state.status
    });

    return <div className="card axs-shadow">
      <div className="card-header">
        <h5>Search Filters</h5>
      </div>
      <div className="card-body">
        <form>
          <div className="form-group">
            <label htmlFor="patientFirstName">Patient First Name</label>
            <input onChange={e => this.setState({ firstName: e.target.value })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.firstName || ''}
              type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label htmlFor="patientLastName">Patient Last Name</label>
            <input onChange={(e) => this.setState({ lastName: e.target.value })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.lastName || ''}
              type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label htmlFor="patientDateOfBirth">Patient Date of Birth</label>
            <NumberFormat
              onValueChange={(e) => this.setState({ dateOfBirth: e.formattedValue })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.dateOfBirth || ''}
              format="##/##/####"
              mask="_"
              name="dateOfBirth"
              className={`form-control ${this.state.invalidDOB ? 'is-invalid' : ''}`}
              placeholder="__/__/____"
            />
          </div>

          <div className="form-group">
            <label htmlFor="providerGroup">Location</label>
            <LocationOption defaultValue={this.state.location}
              handleSelected={(location) => {
                this.setState({ location });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="provider">Provider</label>
            <ProfessionalOption defaultValue={this.state.professional}
              handleSelected={(professional) => {
                this.setState({ professional });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="appointmentDate">Appointment Date</label>
            {this.state.showDateRange ?
              <DateRange
                startDate={this.state.appointmentStartDate}
                endDate={this.state.appointmentEndDate}
                invalidStart={this.state.invalidStart}
                invalidEnd={this.state.invalidEnd}
                handleSearch={this.handleSearch}
                setStartDate={(date) => this.setState({ appointmentStartDate: date })}
                setEndDate={(date) => this.setState({ appointmentEndDate: date })}
              />
              :
              <NumberFormat
                onValueChange={(e) => this.setState({ appointmentDate: e.formattedValue })}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    this.handleSearch();
                  }
                }}
                value={this.state.appointmentDate || ''}
                format="##/##/####"
                mask="_"
                name="appointmentDate"
                className={`form-control ${this.state.invalidDate ? 'is-invalid' : ''}`}
                placeholder="__/__/____"
              />
            }
            <div className="mt-1">
              <a href="/" onClick={this.toggleDateRange}>
                {this.state.showDateRange ? "Date Only" : "Date Range"}
              </a>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="preVisitQuestionId">Pre-Visit Questions</label>
            <PreVisitQuestionOption defaultValue={this.state.preVisitQuestionId}
              handleSelected={(preVisitQuestionId) => {
                this.setState({ preVisitQuestionId });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <Select
              placeholder='By Status'
              isClearable={true}
              options={this.statusOptions}
              onChange={(selected) => {
                if (selected) {
                  this.setState({ status: selected.value })
                } else {
                  this.setState({ status: '' });
                }
              }}
              value={statusSelected || ''}
            />
          </div>

          <button onClick={this.handleSearch} type="button" className="btn btn-primary btn-block">Search</button>

          <button onClick={() => history.push('/telehealth')} type="button" className="btn btn-link btn-block text-center">Clear Filters</button>
        </form>
      </div>
    </div>
  }
}

export default SearchFilters;